import * as types from './types';
import * as constants from './constants';
import { actionBuilder } from './actions';

const state = {
  loading: false,
  selectedIndex: 0,
  options: [],
};

export const getters = {
  getSelectedOption: (state) => {
    return state.options[state.selectedIndex] ?? {};
  },
};

export const mutations = {
  [types.SET_LOADING]: (state, payload) => {
    state.loading = payload;
  },
  [types.SET_SELECTED_INDEX] (state, payload) {
    state.selectedIndex = payload;
  },
  [types.SET_OPTIONS] (state, payload) {
    state.options = payload;
  },
};

const moduleBuilder = (config) => {
  return {
    namespaced: true,
    state,
    actions: actionBuilder(config),
    getters,
    mutations,
  };
};

export default {
  moduleBuilder,
  types,
  constants,
};
